(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var body=document.body;
  var moneyFormat=body.getAttribute('data-money-format')||'${{amount}}';

  function group(s){return s.replace(/\B(?=(\d{3})+(?!\d))/g,',');}
  function formatMoney(cents){
    cents=parseInt(cents,10);if(isNaN(cents))cents=0;
    var value=cents/100;
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g,function(m,name){
      if(name.indexOf('no_decimals')>-1)return group(Math.round(value).toFixed(0));
      return group(value.toFixed(2));
    });
  }

  /* reveal on scroll */
  var io;
  function observeReveal(){
    var els=$$('.reveal:not(.in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
    if(!io)io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.1});
    els.forEach(function(el,i){el.style.transitionDelay=((i%4)*0.07)+'s';io.observe(el);});
  }

  /* mega menu */
  var mega=$('#mega'),shopLi=$('#shopLi'),mt;
  function openMega(){if(mega){mega.classList.add('show');if(shopLi)shopLi.classList.add('open');}}
  function closeMega(){if(mega){mega.classList.remove('show');if(shopLi)shopLi.classList.remove('open');}}
  if(shopLi&&mega){
    shopLi.addEventListener('mouseenter',function(){clearTimeout(mt);openMega();});
    shopLi.addEventListener('mouseleave',function(){mt=setTimeout(closeMega,160);});
    mega.addEventListener('mouseenter',function(){clearTimeout(mt);});
    mega.addEventListener('mouseleave',function(){mt=setTimeout(closeMega,160);});
    var sb=$('#shopBtn');
    if(sb)sb.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();mega.classList.contains('show')?closeMega():openMega();});
  }

  /* overlay + drawers */
  var overlay=$('#overlayBg');
  function closeAll(){
    var cd=$('#cartDrawer');if(cd)cd.classList.remove('show');
    var mn=$('#mnav');if(mn)mn.classList.remove('show');
    if(overlay)overlay.classList.remove('show');
    body.style.overflow='';
  }
  if(overlay)overlay.addEventListener('click',closeAll);

  /* mobile nav */
  var burger=$('#burger');
  if(burger)burger.addEventListener('click',function(){$('#mnav').classList.add('show');if(overlay)overlay.classList.add('show');body.style.overflow='hidden';});
  var cmn=$('#closeMnav');if(cmn)cmn.addEventListener('click',closeAll);
  var mst=$('#mShopToggle');if(mst)mst.addEventListener('click',function(){$('#mSub').classList.toggle('open');});

  /* toast */
  var tt;
  function notify(msg){var t=$('#toast');if(!t)return;t.textContent=msg;t.style.transform='translate(-50%,0)';clearTimeout(tt);tt=setTimeout(function(){t.style.transform='translate(-50%,140%)';},2400);}

  /* cart */
  var cartDrawer=$('#cartDrawer');
  function setCount(n){$$('.cart-count').forEach(function(el){el.textContent=n;el.style.display=n>0?'flex':'none';});}
  function renderCart(cart){
    setCount(cart.item_count);
    var b=$('#cartBody'),total=$('#cartTotal');
    if(!b)return;
    if(cart.item_count===0){b.innerHTML='<div class="cart-empty">Your cart is empty.</div>';if(total)total.textContent=formatMoney(0);return;}
    b.innerHTML=cart.items.map(function(i){
      var img=i.image?('<img src="'+i.image+'" alt="">'):'<div class="glass" style="--t:#eceef0"></div>';
      return '<div class="cart-item"><div class="thumb">'+img+'</div>'+
        '<div><h4>'+i.product_title+'</h4><span class="q">Qty '+i.quantity+'</span></div>'+
        '<div class="pr">'+formatMoney(i.final_line_price)+'</div></div>';
    }).join('');
    if(total)total.textContent=formatMoney(cart.total_price);
  }
  function refreshCart(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart).catch(function(){});}
  function openCart(){if(cartDrawer)cartDrawer.classList.add('show');if(overlay)overlay.classList.add('show');body.style.overflow='hidden';refreshCart();}
  function addToCart(id,qty){
    if(!id)return;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){return r.json();}).then(function(res){
        if(res.status){notify(res.description||'Could not add to cart');return;}
        notify((res.product_title||'Item')+' added');openCart();
      }).catch(function(){notify('Could not add to cart');});
  }
  var cartBtn=$('#cartBtn');if(cartBtn)cartBtn.addEventListener('click',function(e){e.preventDefault();openCart();});
  var ccl=$('#closeCart');if(ccl)ccl.addEventListener('click',closeAll);

  /* quick add on cards */
  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-add-id]');
    if(add){e.preventDefault();e.stopPropagation();addToCart(add.getAttribute('data-add-id'),1);}
  });

  /* PDP form */
  var pform=$('#product-form');
  if(pform){
    pform.addEventListener('submit',function(e){
      e.preventDefault();
      var idEl=pform.querySelector('[name="id"]');
      var qtyEl=pform.querySelector('[name="quantity"]');
      addToCart(idEl?idEl.value:null, qtyEl?qtyEl.value:1);
    });
  }

  /* qty steppers */
  $$('[data-qty]').forEach(function(box){
    var input=box.querySelector('input');
    box.querySelectorAll('a[data-step]').forEach(function(btn){
      btn.addEventListener('click',function(e){e.preventDefault();var d=parseInt(btn.getAttribute('data-step'),10);input.value=Math.max(1,(parseInt(input.value,10)||1)+d);});
    });
  });

  /* variant select */
  var vsel=$('#variant-select');
  if(vsel){
    vsel.addEventListener('change',function(){
      var opt=vsel.options[vsel.selectedIndex];
      var pEl=$('#pdp-price');var price=opt.getAttribute('data-price');
      if(pEl&&price!=null)pEl.textContent=formatMoney(price);
      var avail=opt.getAttribute('data-available')==='true';
      var addBtn=$('#pdp-add');
      if(addBtn){addBtn.disabled=!avail;addBtn.textContent=avail?'Add to cart':'Sold out';}
    });
  }

  /* pdp gallery thumbs */
  $$('.pdp-thumb').forEach(function(th){
    th.addEventListener('click',function(){
      var src=th.getAttribute('data-full');if(!src)return;
      var main=$('#pdpMainImg');if(main)main.src=src;
      $$('.pdp-thumb').forEach(function(x){x.classList.remove('active');});
      th.classList.add('active');
    });
  });

  /* sort dropdown */
  $$('[data-sort]').forEach(function(sel){
    sel.addEventListener('change',function(){
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by',sel.value);url.searchParams.delete('page');
      window.location.href=url.toString();
    });
  });

  observeReveal();
  refreshCart();
})();
